// src/pages/teacher.js - COMPLETELY CLEAN VERSION with NO Firestore/Firebase
import React, { useState, useEffect, useCallback, useRef } from 'react';
import Navbar from '../components/Navbar';
import teacherService from '../services/teacherService';
import { useSocket } from "../context/SocketContext";

function Teacher() {
  const [sessionRequests, setSessionRequests] = useState([]);
  const [hiringRequests, setHiringRequests] = useState([]);
  const [instantRequests, setInstantRequests] = useState([]);
  const [scheduledSessions, setScheduledSessions] = useState([]);
  const [completedSessions, setCompletedSessions] = useState([]);
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showHiringModal, setShowHiringModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [showAvailabilityModal, setShowAvailabilityModal] = useState(false);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [selectedHiringRequest, setSelectedHiringRequest] = useState(null);
  const [selectedSession, setSelectedSession] = useState(null);
  const [activeTab, setActiveTab] = useState('hiring');
  const [teacherProfile, setTeacherProfile] = useState(null);
  const [tokenBalance, setTokenBalance] = useState(0);
  const [loading, setLoading] = useState(false);

  
  
  // State for report submission
  const [showReportModal, setShowReportModal] = useState(false);
  const [selectedStudentForReport, setSelectedStudentForReport] = useState(null);
  const [reportForm, setReportForm] = useState({
    academicPerformance: '',
    strengths: [],
    weaknesses: [],
    learningStyle: '',
    engagementLevel: '',
    behaviorNotes: '',
    recommendations: '',
    subjectMastery: {},
    confidenceLevel: '',
    homeworkCompletion: '',
    attendanceRecord: '',
    participationLevel: ''
  });
const teacherId = localStorage.getItem("userId");
const teacherName = localStorage.getItem('userName');

const hasInitialized = useRef(false);
const { socket } = useSocket();

// ✅ MOVE THIS OUTSIDE useEffect


// ================= SOCKET CONNECTION =================
useEffect(() => {
  if (!socket || !teacherId) return;

  const handleConnect = () => {
    console.log("✅ Socket connected");
    socket.emit("teacher-online", { teacherId });
  };

  if (socket.connected) {
    handleConnect();
  } else {
    socket.on("connect", handleConnect);
  }

  return () => {
    socket.off("connect", handleConnect);
  };
}, [socket, teacherId]);

// ================= INSTANT HELP (SINGLE CLEAN LISTENER) =================
useEffect(() => {
  if (!socket) return;

  const handleInstantHelp = (data) => {
    console.log("⚡ Instant help request received:", data);

    // ✅ POPUP (with countdown support)
    setInstantRequests(prev => {
      const exists = prev.find(r => r.helpRequestId === data.helpRequestId);
      if (exists) return prev;

      return [
        {
          ...data,
          timeLeft: 900, // ⏳ countdown start
          accepting: false
        },
        ...prev
      ];
    });

    // ✅ ALSO ADD TO TABLE (optional but useful)
    setSessionRequests(prev => [
      {
        id: data.helpRequestId,
        studentName: data.studentName,
        subject: data.subject,
        message: data.message,
        status: "pending",
        requestedAt: new Date()
      },
      ...prev
    ]);
  };

  socket.on("instant-help-request", handleInstantHelp);

  return () => {
    socket.off("instant-help-request", handleInstantHelp);
  };
}, [socket]);


// ================= HANDLE ACCEPTED (REMOVE FROM UI) =================
useEffect(() => {
  if (!socket) return;

  const handleAccepted = ({ helpRequestId }) => {
    setInstantRequests(prev =>
      prev.filter(r => r.helpRequestId !== helpRequestId)
    );

    setSessionRequests(prev =>
      prev.filter(r => r.id !== helpRequestId)
    );
  };

  socket.on("instant-help-accepted", handleAccepted);

  return () => {
    socket.off("instant-help-accepted", handleAccepted);
  };
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [socket]);

useEffect(() => {
  if (!scheduledSessions.length) return;

  // 🔍 find active session
  const activeSession = scheduledSessions.find(
    s => s.status === "ongoing"
  );

  if (!activeSession) return;

  console.log("💓 Starting heartbeat for session:", activeSession.id);

  const interval = setInterval(async () => {
    try {
      await teacherService.sendHeartbeat(activeSession.id);
      console.log("💓 Heartbeat sent");
    } catch (err) {
      console.error("❌ Heartbeat failed:", err);
    }
  }, 30000); // every 30 seconds

  return () => {
    console.log("🛑 Stopping heartbeat");
    clearInterval(interval);
  };

}, [scheduledSessions]);

// ================= COUNTDOWN SYSTEM =================
useEffect(() => {
  const interval = setInterval(() => {
    setInstantRequests(prev =>
      prev
        .map(req => ({
          ...req,
          timeLeft: (req.timeLeft || 900) - 1 // ✅ 15 minutes
        }))
        .filter(req => req.timeLeft > 0)
    );
  }, 1000);

  return () => clearInterval(interval);
}, []);

  const [uploadForm, setUploadForm] = useState({
    video: null,
    sessionNotes: ''
  });
  const [profileForm, setProfileForm] = useState({
    experience: '',
    bio: ''
  });

  const [availabilityForm, setAvailabilityForm] = useState({
    monday: { available: false, start: '09:00', end: '17:00' },
    tuesday: { available: false, start: '09:00', end: '17:00' },
    wednesday: { available: false, start: '09:00', end: '17:00' },
    thursday: { available: false, start: '09:00', end: '17:00' },
    friday: { available: false, start: '09:00', end: '17:00' },
    saturday: { available: false, start: '10:00', end: '14:00' },
    sunday: { available: false, start: '10:00', end: '14:00' }
  });

  const [withdrawalForm, setWithdrawalForm] = useState({
    amount: '',
    bankName: '',
    accountNumber: '',
    accountName: ''
  });

  const [scheduleForm, setScheduleForm] = useState({
    scheduleDate: '',
    scheduleTime: '',
    duration: '60'
  });

  const [hiringScheduleForm, setHiringScheduleForm] = useState({
    scheduleDate: '',
    scheduleTime: '',
    duration: '60'
  });

  const [monthlyEarnings, setMonthlyEarnings] = useState({
  totalEarned: 0,
  volunteerSessions: 0,
  paidSessions: 0,
  volunteerEDU: 0,
  paidNaira: 0,
  pendingWithdrawals: 0,
  availableForWithdrawal: 0
});

// ✅ Safe values mapped CORRECTLY to your state
const safeEarnings = {
  paidNaira: Number(monthlyEarnings?.paidNaira || 0),
  pendingWithdrawals: Number(monthlyEarnings?.pendingWithdrawals || 0),
  availableForWithdrawal: Number(monthlyEarnings?.availableForWithdrawal || 0),
  paidSessions: Number(monthlyEarnings?.paidSessions || 0),
  volunteerSessions: Number(monthlyEarnings?.volunteerSessions || 0),
};
  const [paymentHistory, setPaymentHistory] = useState([]);

 
 

  // ============ HELPER FUNCTIONS ============
  
  // Format date safely (handles both string dates and timestamp objects)
  const formatDate = (date) => {
    if (!date) return 'N/A';
    
    try {
      // If it's a timestamp object from backend
      if (date.toDate && typeof date.toDate === 'function') {
        return date.toDate().toLocaleDateString();
      }
      // If it's a string or Date object
      return new Date(date).toLocaleDateString();
    } catch (e) {
      return 'Invalid date';
    }
  };

  // ============ REPORT FUNCTIONS ============
  const handleSubmitReport = async () => {
    if (!selectedStudentForReport) {
      alert('No student selected for report.');
      return;
    }

    if (!reportForm.academicPerformance || !reportForm.learningStyle) {
      alert('Please fill in required fields: Academic Performance and Learning Style.');
      return;
    }

    setLoading(true);
    try {
      // ✅ ALL Firestore logic is now in the backend service
      await teacherService.submitStudentReport({
        teacherId,
        teacherName,
        studentId: selectedStudentForReport.id,
        studentName: selectedStudentForReport.name,
        subject: selectedStudentForReport.subject,
        reportData: reportForm
      });

      alert('Student report submitted successfully! This will help our AI make better predictions for the student.');
      setShowReportModal(false);
      setSelectedStudentForReport(null);
      setReportForm({
        academicPerformance: '',
        strengths: [],
        weaknesses: [],
        learningStyle: '',
        engagementLevel: '',
        behaviorNotes: '',
        recommendations: '',
        subjectMastery: {},
        confidenceLevel: '',
        homeworkCompletion: '',
        attendanceRecord: '',
        participationLevel: ''
      });
      
    } catch (error) {
      console.error('Error submitting report:', error);
      alert('Error submitting report: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

const acceptInstantHelp = async (id) => {
  try {
    console.log("🔥 STEP 1: Function started");

    await teacherService.acceptInstantHelp(id);

    console.log("🔥 STEP 2: Backend call finished");

    // remove request from UI
    setInstantRequests(prev =>
      prev.filter(r => r.helpRequestId !== id)
    );

    // 🔥 ONLY refresh profile from backend (NO manual coins)
    const updatedProfile = await teacherService.fetchTeacherProfile(teacherId);

    console.log("🔥 STEP 3: Profile fetched:", updatedProfile);

    if (updatedProfile) {
      setTeacherProfile(updatedProfile);
    }

    // ❌ NO COIN ALERT HERE
    alert("Session started successfully");

  } catch (err) {
    console.error("❌ ERROR IN ACCEPT:", err);
    alert(err.message);
  }
};
  // ============ DATA LOADING ============
  const loadInitialData = useCallback(async () => {
    
    if (!teacherId) return;
    
    setLoading(true);
    try {
      // Fetch teacher profile
     const profile = await teacherService.getTeacherProfile(teacherId);

if (profile) {
  console.log("✅ Updating profile from backend");

  setTeacherProfile(profile);

  setTokenBalance(profile.tokenBalance || 0);

  if (profile.availability) {
    setAvailabilityForm(profile.availability);
  }
}
      // Fetch all other data in parallel
      const results = await Promise.allSettled([
  teacherService.fetchHiringRequests(teacherId),
  teacherService.fetchSessionRequests(teacherId),
  teacherService.fetchTeacherSessions(teacherId),
  teacherService.calculateMonthlyEarnings(teacherId),
  teacherService.fetchPaymentHistory(teacherId)
]);

const [
  hiringRequestsData,
  sessionRequestsData,
  sessionsData,
  earningsData,
  paymentHistoryData
] = results.map(r => r.status === "fulfilled" ? r.value : null);



setHiringRequests(prev => {
  if (!hiringRequestsData?.requests) return prev;
  return hiringRequestsData.requests;
});

setSessionRequests(prev => {
  if (!sessionRequestsData?.requests) return prev;
  return sessionRequestsData.requests;
});

console.log("🔥 FRONTEND RECEIVED:", sessionsData);
console.log("🧪 ALL SESSIONS ARRAY:", sessionsData?.all);

// ✅ TRUST BACKEND GROUPING
setScheduledSessions([
  ...(sessionsData.scheduled || []),
  ...(sessionsData.ongoing || [])
]);
setCompletedSessions(sessionsData.completed || []);

setMonthlyEarnings(prev => {
  if (!earningsData?.earnings) return prev;
  return earningsData.earnings;
});

setPaymentHistory(prev => {
  if (!paymentHistoryData?.payments) return prev;
  return paymentHistoryData.payments;
});


    } catch (error) {
      console.error('Error loading initial data:', error);
    } finally {
      setLoading(false);
    }
  }, [teacherId]);

  // ============ REALTIME UPDATES ============
useEffect(() => {
  if (!teacherId || hasInitialized.current) return;

  hasInitialized.current = true;

  const unsubscribe = teacherService.setupRealtimeListeners(teacherId, {
    onHiringRequestsUpdate: setHiringRequests,
    onSessionRequestsUpdate: setSessionRequests,
    onSessionsUpdate: (sessions) => {
      const scheduled = sessions.filter(
        s => s.status === 'scheduled' || s.status === 'ongoing'
      );

      const completed = sessions.filter(
        s => s.status === 'completed'
      );

      setScheduledSessions(scheduled);
      setCompletedSessions(completed);
    }
  });

  return () => unsubscribe && unsubscribe();
}, [teacherId]);

  // ============ HIRING REQUEST HANDLERS ============
  const handleAcceptHiringRequest = async () => {
    if (!selectedHiringRequest || !hiringScheduleForm.scheduleDate || !hiringScheduleForm.scheduleTime) {
      alert('Please fill in all schedule details');
      return;
    }

    setLoading(true);
    try {
      // ✅ ALL Firestore logic is now in the backend service
      await teacherService.acceptHiringRequest(
        selectedHiringRequest.id,
        hiringScheduleForm,
        teacherId,
        teacherName
      );

      alert('Hiring request accepted and session scheduled successfully! Payment will be processed automatically.');
      setShowHiringModal(false);
      setSelectedHiringRequest(null);
      setHiringScheduleForm({ scheduleDate: '', scheduleTime: '', duration: '60' });
      
      // Refresh data
      await loadInitialData();
    } catch (error) {
      console.error('Error accepting hiring request:', error);
      alert('Error accepting hiring request: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleRejectHiringRequest = async (requestId) => {
    if (window.confirm('Are you sure you want to reject this hiring request?')) {
      setLoading(true);
      try {
        // ✅ ALL Firestore logic is now in the backend service
        await teacherService.rejectHiringRequest(requestId, teacherId);
        alert('Hiring request rejected.');
        await loadInitialData();
      } catch (error) {
        console.error('Error rejecting hiring request:', error);
        alert('Error rejecting hiring request: ' + error.message);
      } finally {
        setLoading(false);
      }
    }
  };

  // ============ SESSION REQUEST HANDLERS ============
  const handleScheduleSession = async () => {

  if (!selectedRequest || !scheduleForm.scheduleDate || !scheduleForm.scheduleTime) {
    alert('Please fill in all schedule details');
    return;
  }

  setLoading(true);

  try {
    const result = await teacherService.acceptSessionRequest(
      selectedRequest.id,
      teacherId,
      teacherName,
      {
        scheduleDate: scheduleForm.scheduleDate,
        scheduleTime: scheduleForm.scheduleTime,
        duration: scheduleForm.duration
      }
    );

    // ✅ REMOVE FROM REQUESTS
    setSessionRequests(prev =>
      prev.filter(r => r.id !== selectedRequest.id)
    );

    // ✅ ADD TO SCHEDULE (REAL SESSION OBJECT)
    setScheduledSessions(prev => [
      {
        id: result.sessionId,
        studentName: selectedRequest.studentName,
        subject: selectedRequest.subject,
        scheduleDate: scheduleForm.scheduleDate,
        scheduleTime: scheduleForm.scheduleTime,
        duration: scheduleForm.duration,
        meetingLink: result.meetingLink,
        status: "scheduled"
      },
      ...prev
    ]);

    setShowScheduleModal(false);
    setSelectedRequest(null);
    setScheduleForm({ scheduleDate: '', scheduleTime: '', duration: '60' });

    alert(`Session scheduled successfully!\n\nMeeting Link: ${result.meetingLink}`);

  } catch (error) {
    console.error('❌ Error scheduling session:', error);
    alert('Error scheduling session: ' + error.message);
  } finally {
    setLoading(false);
  }
};

  const handleRejectSessionRequest = async (requestId) => {

  if (!window.confirm('Are you sure you want to reject this session request?')) return;

  setLoading(true);

  try {
    await teacherService.rejectSessionRequest(
      requestId,
      teacherId,
      'Teacher declined the request'
    );

    // ✅ REMOVE FROM UI INSTANTLY
    setSessionRequests(prev =>
      prev.filter(r => r.id !== requestId)
    );

    alert('Session request rejected.');

  } catch (error) {
    console.error('Error rejecting session:', error);
    alert('Error rejecting session: ' + error.message);
  } finally {
    setLoading(false);
  }
};
  // ============ SESSION VIDEO HANDLERS ============
  const handleVideoUpload = async () => {
    if (!uploadForm.video) {
      alert('Please select a video file first!');
      return;
    }
    
    if (!selectedSession) {
      alert('No session selected!');
      return;
    }

    setLoading(true);
    try {
      // Upload video
      // ✅ ALL Firestore logic is now in the backend service
      const uploadResult = await teacherService.uploadSessionVideo(
        selectedSession.id,
        teacherId,
        uploadForm.video,
        uploadForm.sessionNotes
      );

      // Complete session with video
      await teacherService.completeSessionWithVideo(
        selectedSession.id,
        uploadResult.videoUrl,
        uploadForm.sessionNotes,
        teacherId
      );

      // Process payment based on session type
      const sessionType = selectedSession.sessionTypeCategory === 'paid' || selectedSession.parentId ? 'hired' : 'volunteer';
      await teacherService.processSessionPayment(selectedSession.id, teacherId, teacherName, sessionType);

      alert('Session video uploaded successfully! Payment has been processed.');
      
      setShowUploadModal(false);
      setUploadForm({ video: null, sessionNotes: '' });
      setSelectedSession(null);
      
      // Refresh data
      await loadInitialData();
      
    } catch (error) {
      console.error('Error uploading video:', error);
      alert('Error uploading video: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // ============ SESSION STATUS HANDLERS ============
  const handleStartSession = async (sessionId) => {
    setLoading(true);
    try {
      // ✅ ALL Firestore logic is now in the backend service
      await teacherService.startSession(sessionId, teacherId);
      alert('Session started! Student has been notified.');
      await loadInitialData();
    } catch (error) {
      console.error('Error starting session:', error);
      alert('Error starting session: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEndSession = async (sessionId) => {
    setLoading(true);
    try {
      // ✅ ALL Firestore logic is now in the backend service
      await teacherService.endSession(sessionId, teacherId);
      alert('Session completed! You can now upload the session video.');
      await loadInitialData();
    } catch (error) {
      console.error('Error ending session:', error);
      alert('Error ending session: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // ============ PROFILE HANDLERS ============
  const handleSaveProfile = async () => {
    if (!profileForm.experience && !profileForm.bio) {
      alert('Please fill in at least one field');
      return;
    }

    setLoading(true);
    try {
      // ✅ ALL Firestore logic is now in the backend service
      await teacherService.updateTeacherProfile(teacherId, profileForm);
      alert('Profile updated successfully!');
      setShowProfileModal(false);
      await loadInitialData();
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Error updating profile: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // ============ AVAILABILITY HANDLERS ============
  const handleSaveAvailability = async () => {
    setLoading(true);
    try {
      // ✅ ALL Firestore logic is now in the backend service
      await teacherService.updateTeacherAvailability(teacherId, availabilityForm);
      alert('Availability settings saved successfully!');
      setShowAvailabilityModal(false);
    } catch (error) {
      console.error('Error saving availability:', error);
      alert('Error saving availability: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // ============ WITHDRAWAL HANDLERS ============
  const handleSubmitWithdrawal = async () => {
    if (!withdrawalForm.amount || withdrawalForm.amount <= 0) {
      alert('Please enter a valid withdrawal amount.');
      return;
    }

    if (!withdrawalForm.bankName || !withdrawalForm.accountNumber || !withdrawalForm.accountName) {
      alert('Please fill in all bank details.');
      return;
    }

    const amount = parseFloat(withdrawalForm.amount);
    const currentBalance = teacherProfile?.nairaBalance || 0;

    if (amount > currentBalance) {
      alert(`Insufficient balance. Available for withdrawal: ₦${currentBalance.toLocaleString()}`);
      return;
    }

    if (amount < 1000) {
      alert('Minimum withdrawal amount is ₦1,000');
      return;
    }

    setLoading(true);
    try {
      // ✅ ALL Firestore logic is now in the backend service
      await teacherService.requestWithdrawal(teacherId, withdrawalForm, teacherName);
      
      alert('Withdrawal request submitted successfully! Admin will process it within 24-48 hours.');
      setShowWithdrawalModal(false);
      setWithdrawalForm({
        amount: '',
        bankName: '',
        accountNumber: '',
        accountName: ''
      });
      
      await loadInitialData();
    } catch (error) {
      console.error('Error submitting withdrawal request:', error);
      alert('Error submitting withdrawal request: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // ============ UTILITY FUNCTIONS ============
  const handleViewReports = () => {
    const totalSessions = completedSessions.length;
    const totalHours = completedSessions.reduce((total, session) => total + (session.duration || 0), 0) / 60;
    const avgSessionDuration = totalSessions > 0 ? (totalHours / totalSessions).toFixed(1) : 0;
    const videosUploaded = completedSessions.filter(session => session.sessionVideo).length;
    const paidSessions = completedSessions.filter(session => session.sessionTypeCategory === 'paid').length;
    const volunteerSessions = completedSessions.filter(session => session.sessionTypeCategory === 'volunteer').length;
    
    alert(`📊 Teaching Report:
  
• Total Sessions: ${totalSessions}
  - Paid Sessions: ${paidSessions}
  - Volunteer Sessions: ${volunteerSessions}
• Total Teaching Hours: ${totalHours.toFixed(1)}
• Average Session Duration: ${avgSessionDuration} hours
• Videos Uploaded: ${videosUploaded}
• EDU Coin Balance: ${tokenBalance} coins
• Naira Balance: ₦${(teacherProfile?.nairaBalance || 0).toLocaleString()}
• Available for Withdrawal: ₦${monthlyEarnings.availableForWithdrawal.toLocaleString()}
• Pending Withdrawals: ₦${monthlyEarnings.pendingWithdrawals.toLocaleString()}
• Total Earnings: ₦${(teacherProfile?.totalEarnings || 0).toLocaleString()}
• Subjects Taught: ${teacherProfile?.subjects?.join(', ') || 'Not set'}

**Note:** EDU coins are earned from volunteer teaching and can be used for platform benefits.
Naira earnings from paid teaching can be withdrawn to your bank account.`);
  };

  const openReportModal = (session) => {
    const studentName = session.childName || session.studentName;
    const studentId = session.childId || session.studentId;
    
    setSelectedStudentForReport({
      id: studentId,
      name: studentName,
      subject: session.subject
    });
    
    setReportForm({
      academicPerformance: '',
      strengths: [],
      weaknesses: [],
      learningStyle: '',
      engagementLevel: '',
      behaviorNotes: '',
      recommendations: '',
      subjectMastery: { [session.subject]: '' },
      confidenceLevel: '',
      homeworkCompletion: '',
      attendanceRecord: '',
      participationLevel: ''
    });
    
    setShowReportModal(true);
  };

  // Helper function to open modals
  const openHiringModal = (request) => {
    setSelectedHiringRequest(request);
    setShowHiringModal(true);
  };

  const openScheduleModal = (request) => {
    setSelectedRequest(request);
    setShowScheduleModal(true);
  };

  const openUploadModal = (session) => {
    setSelectedSession(session);
    setShowUploadModal(true);
  };

  const openEditProfileModal = () => {
    setProfileForm({
      experience: teacherProfile?.experience || '',
      bio: teacherProfile?.bio || ''
    });
    setShowProfileModal(true);
  };

  // ============ UI COMPONENTS ============
  const safeHiringRequests = Array.isArray(hiringRequests) ? hiringRequests : [];
  const safeSessionRequests = Array.isArray(sessionRequests) ? sessionRequests : [];

const renderDashboardHeader = () => (

  <div className="mb-4">

    <div className="p-3 rounded-4 border" style={{ background: "#ffffff" }}>

      <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-3">

        {/* LEFT */}
        <div>

          <h5 className="fw-bold mb-1 text-dark">
            Welcome back,{" "}
            <span style={{ color: "#4f46e5" }}>
              {teacherName ? teacherName.split(" ")[0] : "Teacher"}
            </span>{" "}
            👋
          </h5>

          <div className="d-flex align-items-center gap-2 flex-wrap">

            <span className="badge bg-light text-dark border">
              Teacher Dashboard
            </span>

            <small className="text-muted">
              {new Date().toLocaleDateString("en-US", {
                weekday: "long",
                month: "long",
                day: "numeric",
              })}
            </small>

          </div>

        </div>

        {/* RIGHT */}
        <div className="w-100 w-lg-auto">

          <div className="d-flex flex-wrap gap-2">

            {/* REQUESTS */}
            <div className="px-3 py-1 rounded-pill bg-light d-flex align-items-center gap-1">
              <i className="fas fa-bell text-muted"></i>
              <span className="fw-semibold">
                {safeHiringRequests.length +
                  safeSessionRequests.filter(r => r.status === "pending").length}
              </span>
              <small className="text-muted">Requests</small>
            </div>

            {/* SCHEDULED */}
            <div className="px-3 py-1 rounded-pill bg-light d-flex align-items-center gap-1">
              <i className="fas fa-calendar-check text-muted"></i>
              <span className="fw-semibold">{scheduledSessions.length}</span>
              <small className="text-muted">Scheduled</small>
            </div>

            {/* COINS */}
            <div className="px-3 py-1 rounded-pill bg-light d-flex align-items-center gap-1">
              <i className="fas fa-coins text-muted"></i>
              <span className="fw-semibold">
                {teacherProfile?.eduCoins || 0}
              </span>
              <small className="text-muted">EDU</small>
            </div>

            {/* AVAILABLE (highlight) */}
            <div 
              className="px-3 py-1 rounded-pill d-flex align-items-center gap-1"
              style={{
                background: "#eef2ff",
                color: "#4338ca"
              }}
            >
              <i className="fas fa-wallet"></i>
              <span className="fw-bold">
                ₦{(safeEarnings?.availableForWithdrawal || 0).toLocaleString()}
              </span>
            </div>

          </div>

        </div>

      </div>

      {/* DESCRIPTION */}
      <div className="mt-3">

        <small className="text-muted">
          Manage requests, schedule sessions, and track your earnings.
        </small>

      </div>

    </div>

  </div>
);
const renderStatsCards = () => (
  <div className="row mb-4">

    {/* PAID EARNINGS */}
    <div className="col-md-3">
      <div className="card border-0 shadow-sm rounded-4 h-100">
        <div className="card-body">

          <small className="text-muted">Paid Earnings</small>

          <h4 className="fw-bold text-dark mt-1">
            ₦{safeEarnings.paidNaira.toLocaleString()}
          </h4>

          <small className="text-muted d-block">
            From parent hires
          </small>

          <span className="badge bg-light text-dark border mt-2">
            Withdrawable
          </span>

        </div>
      </div>
    </div>

    {/* EDU COINS */}
    <div className="col-md-3">
      <div className="card border-0 shadow-sm rounded-4 h-100">
        <div className="card-body">

          <small className="text-muted">EDU Coins</small>

          <h4 className="fw-bold text-dark mt-1">
            {teacherProfile?.eduCoins || 0}coins
          </h4>

          <small className="text-muted d-block">
            From volunteer teaching
          </small>

          <span 
            className="badge mt-2"
            style={{ background: "#fef3c7", color: "#92400e" }}
          >
            Platform rewards
          </span>

        </div>
      </div>
    </div>

    {/* SESSIONS */}
    <div className="col-md-3">
      <div className="card border-0 shadow-sm rounded-4 h-100">
        <div className="card-body">

          <small className="text-muted">Sessions</small>

          <h4 className="fw-bold text-dark mt-1">
            {safeEarnings.paidSessions + safeEarnings.volunteerSessions}
          </h4>

          <small className="text-muted d-block">
            This month
          </small>

          <small className="text-muted">
            {safeEarnings.paidSessions} paid, {safeEarnings.volunteerSessions} volunteer
          </small>

        </div>
      </div>
    </div>

    {/* REPORTS */}
    <div className="col-md-3">
      <div className="card border-0 shadow-sm rounded-4 h-100">
        <div className="card-body">

          <small className="text-muted">Student Reports</small>

          <h4 className="fw-bold text-dark mt-1">
            {completedSessions.length}
          </h4>

          <small className="text-muted d-block">
            Sessions completed
          </small>

          <div className="mt-3">
            <button 
              className="btn btn-outline-secondary btn-sm rounded-3 w-100"
              onClick={() => {
                if (completedSessions.length > 0) {
                  setActiveTab('history');
                } else {
                  alert('Complete sessions first to submit reports');
                }
              }}
            >
              Submit Reports
            </button>
          </div>

        </div>
      </div>
    </div>

  </div>
);

  const renderSidebar = () => (
  <div className="col-md-3">

    {/* PROFILE */}
    <div className="card border-0 shadow-sm rounded-4 mb-3">
      <div className="card-body text-center">

        <div
          className="rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
          style={{
            width: "70px",
            height: "70px",
            background: "#e0f2fe", // soft blue
            color: "#0369a1",
            fontSize: "1.6rem",
            fontWeight: "bold"
          }}
        >
          {teacherName?.charAt(0) || "T"}
        </div>

        <h6 className="fw-bold mb-1">{teacherName || "Teacher"}</h6>

        <small className="text-muted d-block mb-2">
          {teacherProfile?.subjects?.join(", ") || "Subjects not set"}
        </small>

      </div>
    </div>

    {/* WALLET */}
    <div 
      className="card border-0 shadow-sm rounded-4 mb-3"
      style={{ background: "#f8fafc" }}
    >
      <div className="card-body">

        {/* EDU */}
        <small className="text-muted">EDU Coins</small>
        <h6 
          className="fw-bold mb-2"
          style={{ color: "#92400e" }}
        >
          {tokenBalance}
        </h6>

        <small className="text-muted d-block mb-3">
          {teacherProfile?.signupBonusAwarded
            ? "Bonus received"
            : "Complete profile for bonus"}
        </small>

        <hr />

        {/* NAIRA */}
        <small className="text-muted">Naira Balance</small>
        <h6 
          className="fw-bold mb-3"
          style={{ color: "#065f46" }}
        >
          ₦{(teacherProfile?.nairaBalance || 0).toLocaleString()}
        </h6>

        <div className="d-grid gap-2">

          <button 
            className="btn btn-sm rounded-3"
            style={{ background: "#111827", color: "white" }}
            onClick={() => setShowWalletModal(true)}
          >
            Wallet
          </button>

          <button 
            className="btn btn-outline-secondary btn-sm rounded-3"
            onClick={() => setShowWithdrawalModal(true)}
          >
            Withdraw
          </button>

          <button 
            className="btn btn-outline-secondary btn-sm rounded-3"
            onClick={() => setShowPaymentModal(true)}
          >
            History
          </button>

        </div>

      </div>
    </div>

    {/* QUICK ACTIONS */}
    <div className="card border-0 shadow-sm rounded-4 mb-3">
      <div className="card-body">

        <small className="text-muted d-block mb-2">Quick Actions</small>

        <div className="d-grid gap-2">

          <button 
            className="btn btn-outline-secondary btn-sm rounded-3"
            onClick={openEditProfileModal}
          >
            Edit Profile
          </button>

          <button 
            className="btn btn-outline-secondary btn-sm rounded-3"
            onClick={() => setShowAvailabilityModal(true)}
          >
            Availability
          </button>

          <button 
            className="btn btn-outline-secondary btn-sm rounded-3"
            onClick={handleViewReports}
          >
            Reports
          </button>

        </div>

      </div>
    </div>

    {/* STATS */}
    <div 
      className="card border-0 shadow-sm rounded-4"
      style={{ background: "#f8fafc" }}
    >
      <div className="card-body">

        <small className="text-muted d-block mb-2">Stats</small>

        <div className="d-flex justify-content-between mb-2">
          <span className="text-muted small">Upcoming</span>
          <span className="fw-semibold text-primary">
            {scheduledSessions.length}
          </span>
        </div>

        <div className="d-flex justify-content-between mb-2">
          <span className="text-muted small">Completed</span>
          <span className="fw-semibold text-success">
            {completedSessions.length}
          </span>
        </div>

        <div className="d-flex justify-content-between mb-2">
          <span className="text-muted small">Paid</span>
          <span className="fw-semibold text-dark">
            {safeEarnings.paidSessions}
          </span>
        </div>

        <div className="d-flex justify-content-between">
          <span className="text-muted small">Volunteer</span>
          <span className="fw-semibold" style={{ color: "#92400e" }}>
            {safeEarnings.volunteerSessions}
          </span>
        </div>

      </div>
    </div>

  </div>
);

  const renderTabContent = () => {
    switch(activeTab) {
      case 'hiring':
        return renderHiringTab();
      case 'requests':
        return renderRequestsTab();
      case 'schedule':
        return renderScheduleTab();
      case 'payments':
        return renderPaymentsTab();
      case 'history':
        return renderHistoryTab();
      default:
        return renderHiringTab();
    }
  };

  const renderHiringTab = () => (
    <div className="card">
      <div className="card-header bg-light">
        <h5 className="card-title mb-0 fw-bold">
          <i className="fas fa-handshake me-2"></i>Hiring Requests from Parents
        </h5>
      </div>
      <div className="card-body">
        {safeHiringRequests.length === 0 ? (
          <div className="text-center py-4">
            <i className="fas fa-handshake fa-3x text-muted mb-3"></i>
            <h5>No pending hiring requests</h5>
            <p className="text-muted">Parents will appear here when they request your services</p>
          </div>
        ) : (
          <div className="row">

  {safeHiringRequests.map(request => {

    const estimatedPayment = (request.hourlyRate * (request.sessionDuration || 60)) / 60;

    return (
      <div key={request.id} className="col-md-6 mb-3">

        <div className="card border-0 shadow-sm rounded-4 h-100">

          <div className="card-body">

            {/* HEADER */}
            <div className="d-flex justify-content-between align-items-start mb-2">

              <div className="d-flex align-items-center gap-2">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: "40px",
                    height: "40px",
                    background: "#e2e8f0",
                    color: "#1e293b",
                    fontWeight: "bold"
                  }}
                >
                  {request.parentName?.charAt(0) || "P"}
                </div>

                <div>
                  <h6 className="fw-bold mb-0">{request.parentName}</h6>
                  <small className="text-muted">{request.childName}</small>
                </div>
              </div>

              <span className="badge bg-light text-dark border">
                {request.subject}
              </span>

            </div>

            {/* DETAILS */}
            <div className="small text-muted mb-3">

              <div>💰 ₦{request.hourlyRate?.toLocaleString()}/hr</div>
              <div>⏱ {request.sessionDuration || 60} mins</div>
              <div>📅 {formatDate(request.requestedDate)}</div>

              <div className="fw-bold text-dark mt-2">
                Estimated: ₦{estimatedPayment.toLocaleString()}
              </div>

            </div>

            {/* ACTIONS */}
            <div className="d-flex gap-2">

              <button
                className="btn btn-dark btn-sm rounded-3 w-100"
                onClick={() => openHiringModal(request)}
              >
                Accept
              </button>

              <button
                className="btn btn-outline-danger btn-sm rounded-3 w-100"
                onClick={() => handleRejectHiringRequest(request.id)}
              >
                Reject
              </button>

            </div>

          </div>

        </div>

      </div>
    );
  })}

</div>
        )}
      </div>
    </div>
  );

  const renderRequestsTab = () => (
    <div className="card">
      <div className="card-header bg-light">
        <h5 className="card-title mb-0 fw-bold">
          <i className="fas fa-calendar-plus me-2"></i>Session Requests (Volunteer)
        </h5>
      </div>
      <div className="card-body">
        <div className="alert alert-info mb-3">
          <i className="fas fa-info-circle me-2"></i>
          Volunteer sessions earn <strong>10 EDU coins per hour</strong> of teaching. These coins help improve your visibility and ratings on the platform.
        </div>
        
        {safeSessionRequests.filter(r => r.status === 'pending').length === 0 ? (
          <div className="text-center py-4">
            <i className="fas fa-calendar-times fa-3x text-muted mb-3"></i>
            <h5>No pending session requests</h5>
            <p className="text-muted">Students will appear here when they request volunteer sessions</p>
          </div>
        ) : (
          
          <div className="table-responsive">
            <table className="table align-middle">
              <thead>
                <tr>
                  <th>Student</th>
                  <th>Subject</th>
                  <th>EDU Coin Reward</th>
                  <th>Date Requested</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {safeSessionRequests
                  .filter(request => request.status === 'pending')
                  .map(request => {
                    const eduReward = Math.floor((request.duration || 60) / 60 * 10);
                    return (
             <tr key={request.id}>

  {/* STUDENT */}
  <td>
    <div className="d-flex align-items-center">
      <div 
        className="rounded-circle d-flex align-items-center justify-content-center me-2"
        style={{
          width: '30px',
          height: '30px',
          background: '#e2e8f0',
          color: '#1e293b',
          fontWeight: 'bold'
        }}
      >
        {request.studentName?.charAt(0) || 'S'}
      </div>
      {request.studentName}
    </div>
  </td>

  {/* SUBJECT */}
  <td>
    <span className="badge bg-light text-dark border">
      {request.subject}
    </span>
  </td>

  {/* REWARD */}
  <td>
    <span 
      className="badge"
      style={{ background: "#fef3c7", color: "#92400e" }}
    >
      <i className="fas fa-coins me-1"></i>
      {eduReward} EDU
    </span>
  </td>

  {/* DATE */}
  <td>{formatDate(request.requestedAt)}</td>

  {/* ACTIONS */}
  <td>
    <div className="d-flex gap-2">

      <button
        className="btn btn-dark btn-sm rounded-3"
        onClick={() => openScheduleModal(request)}
      >
        Schedule
      </button>

      <button
        className="btn btn-outline-danger btn-sm rounded-3"
        onClick={() => handleRejectSessionRequest(request.id)}
      >
        Reject
      </button>

    </div>
  </td>

</tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );

  const renderScheduleTab = () => (
  <div className="card">
    <div className="card-header bg-light">
      <h5 className="card-title mb-0 fw-bold">
        <i className="fas fa-calendar-check me-2"></i>My Schedule ({scheduledSessions.length})
      </h5>
    </div>

    <div className="card-body">
      {scheduledSessions.length === 0 ? (
        <div className="text-center py-5">
    <h6 className="text-muted">No scheduled sessions yet</h6>
    <small className="text-muted">
      Your upcoming sessions will appear here
    </small>
  </div>
      ) : (
    <div className="card border-0 shadow-sm rounded-4 mb-4">

  <div className="table-responsive p-2">

    <table className="table align-middle mb-0">

      <thead className="position-sticky top-0 bg-white">
        <tr>
          <th className="text-muted small fw-semibold">Student</th>
          <th className="text-muted small fw-semibold">Subject</th>
          <th className="text-muted small fw-semibold">Type</th>
          <th className="text-muted small fw-semibold">Date & Time</th>
          <th className="text-muted small fw-semibold">Duration</th>
          <th className="text-muted small fw-semibold">Payment</th>
          <th className="text-muted small fw-semibold">Status</th>
          <th className="text-muted small fw-semibold">Meeting</th>
          <th className="text-muted small fw-semibold">Actions</th>
        </tr>
      </thead>

      <tbody>
        {scheduledSessions.map(session => {

          const sessionDateTime = new Date(`${session.scheduleDate} ${session.scheduleTime}`);
          const canStart = new Date() >= sessionDateTime;

          const isPaid = session.sessionTypeCategory === 'paid' || session.parentId;

          const paymentAmount = isPaid
            ? `₦${((session.hourlyRate || 0) * (session.duration || 60) / 60).toLocaleString()}`
            : `${Math.floor((session.duration || 60) / 60 * 10)} EDU`;

          return (
            <tr key={session.id}>

              {/* STUDENT */}
              <td>
                <div className="d-flex align-items-center">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center me-2"
                    style={{
                      width: '30px',
                      height: '30px',
                      background: '#e2e8f0',
                      color: '#1e293b',
                      fontWeight: 'bold'
                    }}
                  >
                    {session.studentName?.charAt(0) || session.childName?.charAt(0) || 'S'}
                  </div>

                  {session.childName || session.studentName || 'Student'}
                </div>
              </td>

              {/* SUBJECT */}
              <td>
                <span className="badge bg-light text-dark border">
                  {session.subject || 'General'}
                </span>
              </td>

              {/* TYPE */}
              <td>
                <span className={`badge ${isPaid ? 'bg-light text-dark border' : ''}`}
                      style={!isPaid ? { background: "#fef3c7", color: "#92400e" } : {}}>
                  {isPaid ? 'Paid' : 'Volunteer'}
                </span>
              </td>

              {/* DATE */}
              <td>
                <strong>{session.scheduleDate || 'Not set'}</strong><br />
                <small className="text-muted">{session.scheduleTime || 'Not set'}</small>
              </td>

              {/* DURATION */}
              <td>{session.duration || 60} mins</td>

              {/* PAYMENT */}
              <td>
                {session.paymentProcessed ? (
                  <span
                        className="badge"
                        style={{
                        background: "#f1f5f9",
                        color: "#334155",
                        fontWeight: "500"
                         }}
>
                    ✔ Paid
                  </span>
                ) : (
                  <span className="fw-semibold text-dark">{paymentAmount}</span>
                )}
              </td>

              {/* STATUS */}
              <td>
                <span className="badge bg-light text-dark border">
                  {session.status || 'scheduled'}
                </span>
              </td>

              {/* MEETING */}
              <td>
                {session.meetingLink ? (
                  <a
                    href={session.meetingLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-outline-secondary btn-sm rounded-3"
                  >
                    Join Meet
                  </a>
                ) : (
                  <span className="text-muted small">No link</span>
                )}
              </td>

              {/* ACTIONS */}
              <td>

                {/* NORMAL SESSION */}
                {session.status === 'scheduled' && session.sessionMode !== 'instant' && (
                  <button
                    className="btn btn-dark btn-sm rounded-3"
                    onClick={() => handleStartSession(session.id)}
                    disabled={!canStart || loading}
                  >
                    {canStart ? "Start" : "Too Early"}
                  </button>
                )}

                {/* INSTANT HELP */}
                {session.sessionMode === 'instant' && session.status === 'ongoing' && (
                  <div className="d-flex gap-2">
                    <a
                      href={session.meetingLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-secondary btn-sm rounded-3"
                    >
                      Join
                    </a>

                    <button
                      className="btn btn-outline-danger btn-sm rounded-3"
                      onClick={() => handleEndSession(session.id)}
                      disabled={loading}
                    >
                      End
                    </button>
                  </div>
                )}

                {/* FALLBACK */}
                {session.status === 'ongoing' && session.sessionMode !== 'instant' && (
                  <button
                    className="btn btn-outline-danger btn-sm rounded-3"
                    onClick={() => handleEndSession(session.id)}
                    disabled={loading}
                  >
                    End
                  </button>
                )}

              </td>

            </tr>
          );
        })}
      </tbody>

    </table>

  </div>

</div>
      )}
    </div>
  </div>
);

  const renderPaymentsTab = () => (
    <div className="card">
      <div className="card-header bg-light">
        <h5 className="card-title mb-0 fw-bold">
          <i className="fas fa-money-bill-wave me-2"></i>Payments
        </h5>
      </div>
      <div className="card-body">
        <div className="row mb-4">
          <div className="col-md-4">
            <div className="card bg-success text-white">
              <div className="card-body text-center">
                <h5>Total Earnings</h5>
                <h2>₦{(teacherProfile?.totalEarnings || 0).toLocaleString()}</h2>
                <small>All-time paid earnings</small>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card bg-primary text-white">
              <div className="card-body text-center">
                <h5>Available Now</h5>
                <h2>₦{(teacherProfile?.nairaBalance || 0).toLocaleString()}</h2>
                <small>Ready to withdraw</small>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card bg-warning text-dark">
              <div className="card-body text-center">
                <h5>EDU Coins</h5>
                <h2>{tokenBalance} coins</h2>
                <small>For platform benefits</small>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-4">
          <h6 className="fw-bold mb-3">
            <i className="fas fa-history me-2"></i>Recent Transactions
          </h6>
          {paymentHistory.length === 0 ? (
            <div className="alert alert-info">
              <i className="fas fa-info-circle me-2"></i>
              No payment transactions yet. Complete sessions to see payments here.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Type</th>
                    <th>Description</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Reference</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentHistory.slice(0, 10).map(payment => (
                    <tr key={payment.id}>
                      <td>{formatDate(payment.date)}</td>
                      <td>
                        <span className={`badge ${
                          payment.type === 'teacher_payment' ? 'bg-success' :
                          payment.type === 'coin_reward' ? 'bg-warning' :
                          payment.type === 'signup_bonus' ? 'bg-info' :
                          payment.type === 'withdrawal' ? 'bg-primary' : 'bg-secondary'
                        }`}>
                          {payment.type.replace('_', ' ')}
                        </span>
                      </td>
                      <td>{payment.description}</td>
                      <td>
                        {payment.currency === 'edu' || payment.type === 'coin_reward' || payment.type === 'signup_bonus' ? (
                          <span className="text-warning fw-bold">{payment.coinAmount || payment.amount} EDU</span>
                        ) : (
                          <span className="text-success fw-bold">₦{payment.amount?.toLocaleString()}</span>
                        )}
                      </td>
                      <td>
                        <span className={`badge ${
                          payment.status === 'completed' ? 'bg-success' :
                          payment.status === 'pending' ? 'bg-warning' : 'bg-danger'
                        }`}>
                          {payment.status}
                        </span>
                      </td>
                      <td><small>{payment.reference}</small></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="d-flex gap-2">
          <button className="btn btn-primary" onClick={() => setShowWithdrawalModal(true)}>
            <i className="fas fa-download me-2"></i>Request Withdrawal
          </button>
          <button className="btn btn-outline-primary" onClick={() => setShowWalletModal(true)}>
            <i className="fas fa-wallet me-2"></i>View Wallet Details
          </button>
        </div>
      </div>
    </div>
  );

  const renderHistoryTab = () => (
  <div className="card border-0 shadow-sm rounded-4">

    {/* HEADER */}
    <div className="card-header bg-white border-0">
      <h5 className="fw-bold mb-0">
        <i className="fas fa-history me-2 text-muted"></i>
        Session History
      </h5>
    </div>

    <div className="card-body">

      {/* INFO */}
      <div 
        className="rounded-3 p-3 mb-4"
        style={{ background: "#f8fafc", fontSize: "0.9rem" }}
      >
        <i className="fas fa-info-circle me-2 text-muted"></i>
        Submit student reports after sessions to improve AI recommendations.
      </div>

      {completedSessions.length === 0 ? (
        <div className="text-center py-5">
          <i className="fas fa-history fa-2x text-muted mb-3"></i>
          <h6 className="fw-bold">No completed sessions yet</h6>
          <small className="text-muted">
            Complete your first session to see history here
          </small>
        </div>
      ) : (

        <div 
          className="table-responsive rounded-4"
          style={{ border: "1px solid #f1f5f9" }}
        >

          <table className="table align-middle mb-0">

            {/* HEADER */}
            <thead style={{ background: "#f8fafc" }}>
              <tr className="text-muted small">
                <th className="fw-semibold">Student</th>
                <th className="fw-semibold">Subject</th>
                <th className="fw-semibold">Type</th>
                <th className="fw-semibold">Date</th>
                <th className="fw-semibold">Duration</th>
                <th className="fw-semibold">Payment</th>
                <th className="fw-semibold">Status</th>
                <th className="fw-semibold text-end">Actions</th>
              </tr>
            </thead>

            <tbody>
              {completedSessions.map(session => {
                const isPaid = session.sessionTypeCategory === 'paid' || session.parentId;
                const paymentAmount = session.paymentAmount || session.eduAwarded;
                const paymentCurrency = session.paymentAmount ? '₦' : 'EDU';
                const hasReport = session.teacherReportSubmitted;

                return (
                  <tr key={session.id} style={{ borderTop: "1px solid #f1f5f9" }}>

                    {/* STUDENT */}
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: "32px",
                            height: "32px",
                            background: "#eef2ff",
                            color: "#4f46e5",
                            fontSize: "0.8rem",
                            fontWeight: "600"
                          }}
                        >
                          {(session.studentName || session.childName || "S").charAt(0)}
                        </div>

                        <span className="fw-medium">
                          {session.childName || session.studentName}
                        </span>
                      </div>
                    </td>

                    {/* SUBJECT */}
                    <td>
                      <span 
                        className="px-2 py-1 rounded-3"
                        style={{ background: "#f1f5f9", fontSize: "0.75rem" }}
                      >
                        {session.subject}
                      </span>
                    </td>

                    {/* TYPE */}
                    <td>
                      <span className="text-muted small">
                        {isPaid ? "Paid" : "Volunteer"}
                      </span>
                    </td>

                    {/* DATE */}
                    <td className="text-muted small">
                      {formatDate(session.endTime)}
                    </td>

                    {/* DURATION */}
                    <td className="text-muted small">
                      {session.duration} mins
                    </td>

                    {/* PAYMENT */}
                    <td>
                      {session.paymentProcessed ? (
                        <span className="fw-semibold">
                          {paymentCurrency}{paymentAmount?.toLocaleString()}
                        </span>
                      ) : (
                        <small className="text-muted">Pending</small>
                      )}
                    </td>

                    {/* STATUS */}
                    <td>
                      {hasReport ? (
                        <span 
                          className="px-2 py-1 rounded-3 small"
                          style={{ background: "#ecfdf5", color: "#065f46" }}
                        >
                          Completed
                        </span>
                      ) : (
                        <span 
                          className="px-2 py-1 rounded-3 small"
                          style={{ background: "#fef3c7", color: "#92400e" }}
                        >
                          Pending
                        </span>
                      )}
                    </td>

                    {/* ACTIONS */}
                    <td className="text-end">
                      <div className="d-flex gap-2 justify-content-end flex-wrap">

                        {!session.sessionVideo && (
                          <button 
                            className="btn btn-outline-primary btn-sm rounded-3"
                            onClick={() => openUploadModal(session)}
                            disabled={loading}
                          >
                            Upload
                          </button>
                        )}

                        {session.sessionVideo && !hasReport && (
                          <button 
                            className="btn btn-outline-success btn-sm rounded-3"
                            onClick={() => openReportModal(session)}
                            disabled={loading}
                          >
                            Report
                          </button>
                        )}

                        {session.sessionVideo && hasReport && (
                          <button 
                            className="btn btn-outline-warning btn-sm rounded-3"
                            onClick={() => openReportModal(session)}
                            disabled={loading}
                          >
                            Update
                          </button>
                        )}

                        {session.sessionVideo && (
                          <a 
                            href={session.sessionVideo}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-outline-secondary btn-sm rounded-3"
                          >
                            View
                          </a>
                        )}

                      </div>
                    </td>

                  </tr>
                );
              })}
            </tbody>

          </table>

        </div>

      )}
    </div>
  </div>
);

  // ============ MODALS ============
  function renderModals() {
    return (
      <>
        {/* Student Report Modal */}
        {showReportModal && selectedStudentForReport && (
          <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    <i className="fas fa-clipboard-check me-2"></i>
                    Student Report - {selectedStudentForReport.name}
                  </h5>
                  <button type="button" className="btn-close" onClick={() => setShowReportModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="alert alert-info mb-3">
                    <i className="fas fa-info-circle me-2"></i>
                    <strong>This report will be used by our AI system</strong> to make predictions and generate personalized learning plans for the student.
                    Please provide accurate observations to help improve their learning experience.
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold">Academic Performance *</label>
                      <select 
                        className="form-select" 
                        value={reportForm.academicPerformance}
                        onChange={(e) => setReportForm({...reportForm, academicPerformance: e.target.value})}
                        required
                      >
                        <option value="">Select performance level</option>
                        <option value="Excellent">Excellent (Top 10%)</option>
                        <option value="Good">Good (Above Average)</option>
                        <option value="Average">Average</option>
                        <option value="Below Average">Below Average</option>
                        <option value="Needs Improvement">Needs Significant Improvement</option>
                      </select>
                    </div>
                    
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold">Learning Style *</label>
                      <select 
                        className="form-select" 
                        value={reportForm.learningStyle}
                        onChange={(e) => setReportForm({...reportForm, learningStyle: e.target.value})}
                        required
                      >
                        <option value="">Select learning style</option>
                        <option value="Visual">Visual (Learns by seeing)</option>
                        <option value="Auditory">Auditory (Learns by hearing)</option>
                        <option value="Kinesthetic">Kinesthetic (Hands-on learning)</option>
                        <option value="Reading/Writing">Reading/Writing</option>
                        <option value="Mixed">Mixed/Combination</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">Strengths</label>
                    <div className="row">
                      {['Concept Understanding', 'Problem Solving', 'Creativity', 'Critical Thinking', 'Communication', 'Attention to Detail', 'Memory Retention', 'Application of Knowledge'].map(strength => (
                        <div key={strength} className="col-md-6 mb-2">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={reportForm.strengths.includes(strength)}
                              onChange={(e) => {
                                const strengths = [...reportForm.strengths];
                                if (e.target.checked) {
                                  strengths.push(strength);
                                } else {
                                  const index = strengths.indexOf(strength);
                                  if (index > -1) strengths.splice(index, 1);
                                }
                                setReportForm({...reportForm, strengths});
                              }}
                            />
                            <label className="form-check-label">{strength}</label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">Areas for Improvement</label>
                    <div className="row">
                      {['Time Management', 'Concept Understanding', 'Practice Consistency', 'Exam Preparation', 'Focus & Concentration', 'Confidence', 'Homework Completion', 'Asking Questions'].map(weakness => (
                        <div key={weakness} className="col-md-6 mb-2">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              checked={reportForm.weaknesses.includes(weakness)}
                              onChange={(e) => {
                                const weaknesses = [...reportForm.weaknesses];
                                if (e.target.checked) {
                                  weaknesses.push(weakness);
                                } else {
                                  const index = weaknesses.indexOf(weakness);
                                  if (index > -1) weaknesses.splice(index, 1);
                                }
                                setReportForm({...reportForm, weaknesses});
                              }}
                            />
                            <label className="form-check-label">{weakness}</label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold">Engagement Level</label>
                      <select 
                        className="form-select" 
                        value={reportForm.engagementLevel}
                        onChange={(e) => setReportForm({...reportForm, engagementLevel: e.target.value})}
                      >
                        <option value="">Select engagement level</option>
                        <option value="Very High">Very High (Always engaged)</option>
                        <option value="High">High (Usually engaged)</option>
                        <option value="Moderate">Moderate (Sometimes engaged)</option>
                        <option value="Low">Low (Rarely engaged)</option>
                        <option value="Very Low">Very Low (Disengaged)</option>
                      </select>
                    </div>
                    
                    <div className="col-md-6 mb-3">
                      <label className="form-label fw-bold">Confidence Level</label>
                      <select 
                        className="form-select" 
                        value={reportForm.confidenceLevel}
                        onChange={(e) => setReportForm({...reportForm, confidenceLevel: e.target.value})}
                      >
                        <option value="">Select confidence level</option>
                        <option value="Very Confident">Very Confident</option>
                        <option value="Confident">Confident</option>
                        <option value="Moderately Confident">Moderately Confident</option>
                        <option value="Not Confident">Not Confident</option>
                        <option value="Anxious">Anxious/Insecure</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">Subject Mastery - {selectedStudentForReport.subject}</label>
                    <select 
                      className="form-select" 
                      value={reportForm.subjectMastery[selectedStudentForReport.subject] || ''}
                      onChange={(e) => setReportForm({
                        ...reportForm,
                        subjectMastery: {
                          ...reportForm.subjectMastery,
                          [selectedStudentForReport.subject]: e.target.value
                        }
                      })}
                    >
                      <option value="">Select mastery level</option>
                      <option value="Mastered">Mastered (100%)</option>
                      <option value="Proficient">Proficient (80-99%)</option>
                      <option value="Competent">Competent (60-79%)</option>
                      <option value="Developing">Developing (40-59%)</option>
                      <option value="Beginning">Beginning (0-39%)</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">Behavior & Attitude Notes</label>
                    <textarea 
                      className="form-control" 
                      rows="3"
                      value={reportForm.behaviorNotes}
                      onChange={(e) => setReportForm({...reportForm, behaviorNotes: e.target.value})}
                      placeholder="Describe student's behavior, attitude, and classroom demeanor..."
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label fw-bold">Recommendations for Improvement</label>
                    <textarea 
                      className="form-control" 
                      rows="3"
                      value={reportForm.recommendations}
                      onChange={(e) => setReportForm({...reportForm, recommendations: e.target.value})}
                      placeholder="Provide specific recommendations for the student's improvement..."
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowReportModal(false)}>
                    Cancel
                  </button>
                  <button 
                    type="button" 
                    className="btn btn-primary" 
                    onClick={handleSubmitReport}
                    disabled={!reportForm.academicPerformance || !reportForm.learningStyle || loading}
                  >
                    {loading ? 'Submitting...' : 'Submit Report for AI Analysis'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Upload Video Modal */}
        {showUploadModal && selectedSession && (
          <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    Upload Lesson Video - {selectedSession.sessionTypeCategory === 'paid' ? 'Paid Session' : 'Volunteer Session'}
                  </h5>
                  <button type="button" className="btn-close" onClick={() => setShowUploadModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="alert alert-info">
                    <strong>Session Details:</strong><br/>
                    <strong>Student:</strong> {selectedSession.childName || selectedSession.studentName}<br/>
                    <strong>Subject:</strong> {selectedSession.subject}<br/>
                    <strong>Date:</strong> {selectedSession.scheduleDate} at {selectedSession.scheduleTime}<br/>
                    <strong>Type:</strong> {selectedSession.sessionTypeCategory === 'paid' ? 'Paid' : 'Volunteer'}<br/>
                    {selectedSession.sessionTypeCategory === 'paid' ? (
                      <><strong>Payment:</strong> ₦{((selectedSession.hourlyRate || 0) * (selectedSession.duration || 60) / 60).toLocaleString()}</>
                    ) : (
                      <><strong>EDU Coin Reward:</strong> {Math.floor((selectedSession.duration || 60) / 60 * 10)} EDU</>
                    )}
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">
                      <strong>Select Lesson Video *</strong>
                    </label>
                    <input 
                      type="file" 
                      className="form-control" 
                      accept="video/*" 
                      onChange={(e) => setUploadForm({...uploadForm, video: e.target.files[0]})}
                    />
                    <div className="form-text">
                      {selectedSession.sessionTypeCategory === 'paid' 
                        ? 'Upload the recorded session video to receive payment'
                        : 'Upload the recorded session video to receive EDU coins'}
                    </div>
                    {uploadForm.video && (
                      <div className="alert alert-success mt-2">
                        <strong>Selected:</strong> {uploadForm.video.name} 
                        ({(uploadForm.video.size / (1024 * 1024)).toFixed(2)} MB)
                      </div>
                    )}
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">
                      <strong>Session Notes (Optional)</strong>
                    </label>
                    <textarea 
                      className="form-control" 
                      rows="4" 
                      value={uploadForm.sessionNotes} 
                      onChange={(e) => setUploadForm({...uploadForm, sessionNotes: e.target.value})}
                      placeholder="Describe what was covered in this session..."
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowUploadModal(false)}>Cancel</button>
                  <button type="button" className="btn btn-primary" onClick={handleVideoUpload} disabled={!uploadForm.video || loading}>
                    {loading ? 'Uploading...' : 'Upload Video & Complete Session'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Hiring Modal */}
        {showHiringModal && selectedHiringRequest && (
          <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Schedule Session for {selectedHiringRequest.childName}</h5>
                  <button type="button" className="btn-close" onClick={() => setShowHiringModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="alert alert-info">
                    <strong>Request Details:</strong><br/>
                    <strong>Parent:</strong> {selectedHiringRequest.parentName}<br/>
                    <strong>Student:</strong> {selectedHiringRequest.childName}<br/>
                    <strong>Subject:</strong> {selectedHiringRequest.subject}<br/>
                    <strong>Rate:</strong> ₦{selectedHiringRequest.hourlyRate}/hr<br/>
                    <strong>Estimated Payment:</strong> ₦{((selectedHiringRequest.hourlyRate * (selectedHiringRequest.sessionDuration || 60)) / 60).toLocaleString()}<br/>
                    <strong>Preferred Days:</strong> {selectedHiringRequest.preferredDays?.join(', ') || 'Any'}
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Date</label>
                    <input type="date" className="form-control" value={hiringScheduleForm.scheduleDate} 
                          onChange={(e) => setHiringScheduleForm({...hiringScheduleForm, scheduleDate: e.target.value})} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Time</label>
                    <input type="time" className="form-control" value={hiringScheduleForm.scheduleTime} 
                          onChange={(e) => setHiringScheduleForm({...hiringScheduleForm, scheduleTime: e.target.value})} required />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Duration (minutes)</label>
                    <select className="form-select" value={hiringScheduleForm.duration} 
                            onChange={(e) => setHiringScheduleForm({...hiringScheduleForm, duration: e.target.value})}>
                      <option value="30">30 minutes</option>
                      <option value="60">60 minutes</option>
                      <option value="90">90 minutes</option>
                      <option value="120">120 minutes</option>
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowHiringModal(false)}>Cancel</button>
                  <button type="button" className="btn btn-primary" onClick={handleAcceptHiringRequest}
                          disabled={!hiringScheduleForm.scheduleDate || !hiringScheduleForm.scheduleTime || loading}>
                    {loading ? 'Processing...' : 'Accept & Schedule'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Schedule Modal - Volunteer Sessions */}
        {showScheduleModal && selectedRequest && (
          <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Schedule Volunteer Session with {selectedRequest.studentName}</h5>
                  <button type="button" className="btn-close" onClick={() => setShowScheduleModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="alert alert-warning">
                    <i className="fas fa-info-circle me-2"></i>
                    This is a volunteer session. You will earn <strong>10 EDU coins per hour</strong> of teaching. EDU coins help improve your visibility and ratings on the platform.
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Date</label>
                    <input 
                      type="date" 
                      className="form-control" 
                      value={scheduleForm.scheduleDate} 
                      onChange={(e) => setScheduleForm({...scheduleForm, scheduleDate: e.target.value})} 
                      required 
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Time</label>
                    <input 
                      type="time" 
                      className="form-control" 
                      value={scheduleForm.scheduleTime} 
                      onChange={(e) => setScheduleForm({...scheduleForm, scheduleTime: e.target.value})} 
                      required 
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Duration (minutes)</label>
                    <select 
                      className="form-select" 
                      value={scheduleForm.duration} 
                      onChange={(e) => setScheduleForm({...scheduleForm, duration: e.target.value})}
                    >
                      <option value="30">30 minutes (5 EDU)</option>
                      <option value="60">60 minutes (10 EDU)</option>
                      <option value="90">90 minutes (15 EDU)</option>
                      <option value="120">120 minutes (20 EDU)</option>
                    </select>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowScheduleModal(false)}>Cancel</button>
                  <button 
                    type="button" 
                    className="btn btn-primary" 
                    onClick={handleScheduleSession}
                    disabled={!scheduleForm.scheduleDate || !scheduleForm.scheduleTime || loading}
                  >
                    {loading ? 'Scheduling...' : 'Schedule Volunteer Session'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Profile Modal */}
        {showProfileModal && (
          <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Profile</h5>
                  <button type="button" className="btn-close" onClick={() => setShowProfileModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Experience (Years)</label>
                    <input 
                      type="number" 
                      className="form-control" 
                      value={profileForm.experience} 
                      onChange={(e) => setProfileForm({...profileForm, experience: e.target.value})}
                      min="0"
                      max="50"
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Bio</label>
                    <textarea 
                      className="form-control" 
                      rows="4" 
                      value={profileForm.bio} 
                      onChange={(e) => setProfileForm({...profileForm, bio: e.target.value})}
                      placeholder="Tell students and parents about your teaching style, qualifications, and experience..."
                    ></textarea>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowProfileModal(false)}>Cancel</button>
                  <button type="button" className="btn btn-primary" onClick={handleSaveProfile} disabled={loading}>
                    {loading ? 'Saving...' : 'Save Changes'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Availability Modal */}
        {showAvailabilityModal && (
          <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Set Your Availability</h5>
                  <button type="button" className="btn-close" onClick={() => setShowAvailabilityModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="alert alert-info">
                    <i className="fas fa-info-circle me-2"></i>
                    Set your available hours for teaching. This helps students and parents know when you're available for sessions.
                  </div>
                  
                  {Object.entries(availabilityForm).map(([day, schedule]) => (
                    <div key={day} className="mb-3">
                      <div className="form-check">
                        <input 
                          className="form-check-input" 
                          type="checkbox" 
                          id={`available-${day}`}
                          checked={schedule.available}
                          onChange={(e) => setAvailabilityForm({
                            ...availabilityForm,
                            [day]: {...schedule, available: e.target.checked}
                          })}
                        />
                        <label className="form-check-label fw-bold" htmlFor={`available-${day}`}>
                          {day.charAt(0).toUpperCase() + day.slice(1)}
                        </label>
                      </div>
                      
                      {schedule.available && (
                        <div className="row mt-2">
                          <div className="col">
                            <label className="form-label small">Start Time</label>
                            <input 
                              type="time" 
                              className="form-control form-control-sm" 
                              value={schedule.start}
                              onChange={(e) => setAvailabilityForm({
                                ...availabilityForm,
                                [day]: {...schedule, start: e.target.value}
                              })}
                            />
                          </div>
                          <div className="col">
                            <label className="form-label small">End Time</label>
                            <input 
                              type="time" 
                              className="form-control form-control-sm" 
                              value={schedule.end}
                              onChange={(e) => setAvailabilityForm({
                                ...availabilityForm,
                                [day]: {...schedule, end: e.target.value}
                              })}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowAvailabilityModal(false)}>Cancel</button>
                  <button type="button" className="btn btn-primary" onClick={handleSaveAvailability} disabled={loading}>
                    {loading ? 'Saving...' : 'Save Availability'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Wallet Modal */}
        {showWalletModal && (
          <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">My Wallet</h5>
                  <button type="button" className="btn-close" onClick={() => setShowWalletModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="card bg-warning text-dark mb-3">
                        <div className="card-body text-center">
                          <h5 className="card-title">EDU Coin Wallet</h5>
                          <h2>{tokenBalance} coins</h2>
                          <p className="card-text">
                            Earned from volunteer teaching sessions
                          </p>
                          <div className="alert alert-light mt-2">
                            <small>
                              <strong>EDU Coin Benefits:</strong><br/>
                              • Improve your profile visibility<br/>
                              • Get featured in search results<br/>
                              • Earn badges and achievements<br/>
                              • Access premium features
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="card bg-success text-white mb-3">
                        <div className="card-body text-center">
                          <h5 className="card-title">Naira Wallet</h5>
                          <h2>₦{(teacherProfile?.nairaBalance || 0).toLocaleString()}</h2>
                          <p className="card-text">
                            Earned from paid teaching sessions
                          </p>
                          <div className="alert alert-light mt-2">
                            <small>
                              <strong>Withdrawal Information:</strong><br/>
                              • Minimum withdrawal: ₦1,000<br/>
                              • Processing time: 24-48 hours<br/>
                              • Bank transfer only<br/>
                              • No withdrawal fees
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="card">
                    <div className="card-body">
                      <h6 className="fw-bold">How to Earn</h6>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="d-flex align-items-center mb-2">
                            <i className="fas fa-coins text-warning me-2"></i>
                            <div>
                              <strong>EDU Coins:</strong>
                              <small className="d-block">• Volunteer teaching: 10 coins/hour</small>
                              <small className="d-block">• Profile completion: 10 coins (bonus)</small>
                              <small className="d-block">• Student reports: 5 coins/report</small>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="d-flex align-items-center mb-2">
                            <i className="fas fa-money-bill-wave text-success me-2"></i>
                            <div>
                              <strong>Naira Earnings:</strong>
                              <small className="d-block">• Parent hires: Your hourly rate</small>
                              <small className="d-block">• Automatically paid after session completion</small>
                              <small className="d-block">• Submit reports to help AI predictions</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowWalletModal(false)}>Close</button>
                  <button type="button" className="btn btn-primary" onClick={() => setShowWithdrawalModal(true)}>
                    <i className="fas fa-download me-1"></i>Withdraw Funds
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Withdrawal Modal */}
        {showWithdrawalModal && (
          <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Request Withdrawal</h5>
                  <button type="button" className="btn-close" onClick={() => setShowWithdrawalModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="alert alert-info mb-3">
                    <strong>Available Balance:</strong> ₦{(teacherProfile?.nairaBalance || 0).toLocaleString()}<br/>
                    <strong>Minimum Withdrawal:</strong> ₦1,000<br/>
                    <strong>Processing Time:</strong> 24-48 hours
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Amount (₦)</label>
                    <input 
                      type="number" 
                      className="form-control" 
                      value={withdrawalForm.amount} 
                      onChange={(e) => setWithdrawalForm({...withdrawalForm, amount: e.target.value})}
                      placeholder="Enter amount to withdraw"
                      min="1000"
                      max={teacherProfile?.nairaBalance || 0}
                    />
                    <div className="form-text">
                      Available: ₦{(teacherProfile?.nairaBalance || 0).toLocaleString()}
                    </div>
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Bank Name</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={withdrawalForm.bankName} 
                      onChange={(e) => setWithdrawalForm({...withdrawalForm, bankName: e.target.value})}
                      placeholder="Enter your bank name"
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Account Number</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={withdrawalForm.accountNumber} 
                      onChange={(e) => setWithdrawalForm({...withdrawalForm, accountNumber: e.target.value})}
                      placeholder="Enter your account number"
                    />
                  </div>
                  
                  <div className="mb-3">
                    <label className="form-label">Account Name</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={withdrawalForm.accountName} 
                      onChange={(e) => setWithdrawalForm({...withdrawalForm, accountName: e.target.value})}
                      placeholder="Enter account name as it appears on bank records"
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowWithdrawalModal(false)}>Cancel</button>
                  <button type="button" className="btn btn-primary" onClick={handleSubmitWithdrawal}
                          disabled={!withdrawalForm.amount || !withdrawalForm.bankName || !withdrawalForm.accountNumber || !withdrawalForm.accountName || loading}>
                    {loading ? 'Submitting...' : 'Submit Withdrawal Request'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Payment History Modal */}
        {showPaymentModal && (
          <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            <div className="modal-dialog modal-xl">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Payment History</h5>
                  <button type="button" className="btn-close" onClick={() => setShowPaymentModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="row mb-4">
                    <div className="col-md-3">
                      <div className="card bg-success text-white">
                        <div className="card-body text-center">
                          <h6>Total Earned</h6>
                          <h4>₦{(teacherProfile?.totalEarnings || 0).toLocaleString()}</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="card bg-primary text-white">
                        <div className="card-body text-center">
                          <h6>Available</h6>
                          <h4>₦{(teacherProfile?.nairaBalance || 0).toLocaleString()}</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="card bg-warning text-dark">
                        <div className="card-body text-center">
                          <h6>EDU Coins</h6>
                          <h4>{tokenBalance} coins</h4>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="card bg-info text-white">
                        <div className="card-body text-center">
                          <h6>This Month</h6>
                          <h4>₦{monthlyEarnings.paidNaira.toLocaleString()}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {paymentHistory.length === 0 ? (
                    <div className="text-center py-4">
                      <i className="fas fa-history fa-3x text-muted mb-3"></i>
                      <h5>No payment history yet</h5>
                      <p className="text-muted">Complete sessions to see payment history here</p>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Date</th>
                            <th>Type</th>
                            <th>Description</th>
                            <th>From/To</th>
                            <th>Amount</th>
                            <th>Status</th>
                            <th>Reference</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paymentHistory.map(payment => (
                            <tr key={payment.id}>
                              <td>{formatDate(payment.date)}</td>
                              <td>
                                <span className={`badge ${
                                  payment.type === 'teacher_payment' ? 'bg-success' :
                                  payment.type === 'coin_reward' ? 'bg-warning' :
                                  payment.type === 'signup_bonus' ? 'bg-info' :
                                  payment.type === 'withdrawal' ? 'bg-primary' : 'bg-secondary'
                                }`}>
                                  {payment.type.replace('_', ' ')}
                                </span>
                              </td>
                              <td>{payment.description}</td>
                              <td>
                                {payment.senderName ? `From: ${payment.senderName}` : 
                                  payment.recipientName ? `To: ${payment.recipientName}` : 'System'}
                              </td>
                              <td>
                                {payment.currency === 'edu' || payment.type === 'coin_reward' || payment.type === 'signup_bonus' ? (
                                  <span className="text-warning fw-bold">
                                    <i className="fas fa-coins me-1"></i>
                                    {payment.coinAmount || payment.amount} EDU
                                  </span>
                                ) : (
                                  <span className="text-success fw-bold">
                                    <i className="fas fa-naira-sign me-1"></i>
                                    {payment.amount?.toLocaleString()}
                                  </span>
                                )}
                              </td>
                              <td>
                                <span className={`badge ${
                                  payment.status === 'completed' ? 'bg-success' :
                                  payment.status === 'pending' ? 'bg-warning' : 'bg-danger'
                                }`}>
                                  {payment.status}
                                </span>
                              </td>
                              <td><small>{payment.reference}</small></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowPaymentModal(false)}>Close</button>
                  <button type="button" className="btn btn-primary" onClick={() => setShowWithdrawalModal(true)}>
                    <i className="fas fa-download me-1"></i>Request Withdrawal
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
  

  return (
    
    <div>
      <Navbar />
      
      <div 
  className="container mt-4"
  style={{ 
    maxWidth: "1200px",
    paddingLeft: "20px",
    paddingRight: "20px",
    
  }}
>
        {!teacherId ? (
          <div className="alert alert-danger">
            Please log in to access the teacher dashboard.
          </div>
        ) : loading && !teacherProfile ? (
          <div className="text-center py-4">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading dashboard...</p>
          </div>
        ) : (
          <>
            {renderDashboardHeader()}
            {renderStatsCards()}
            
     <div className="instant-help-container">
  {instantRequests.map(req => (
    <div key={req.helpRequestId} className="instant-help-popup shadow">

      <div className="d-flex justify-content-between align-items-center mb-2">
        <strong>⚡ Instant Help</strong>
        <span className="badge bg-success">+5 EduCoins</span>
      </div>

      <p className="mb-1">
        <strong>{req.studentName}</strong>
      </p>

      <p className="mb-2 text-muted">
        {req.subject}
      </p>

      {/* 🔥 COUNTDOWN */}
      <div className="mb-2 text-danger fw-bold">
        ⏳ {req.timeLeft || 900}s remaining
      </div>

      <button
  className="btn btn-success btn-sm w-100"
  disabled={req.accepting}
  onClick={async () => {

    if (req.accepting) return; // 🛑 prevent double click

    setInstantRequests(prev =>
      prev.map(r =>
        r.helpRequestId === req.helpRequestId
          ? { ...r, accepting: true }
          : r
      )
    );

    try {
      await acceptInstantHelp(req.helpRequestId);
    } catch (err) {
      console.error(err);

      setInstantRequests(prev =>
        prev.map(r =>
          r.helpRequestId === req.helpRequestId
            ? { ...r, accepting: false }
            : r
        )
      );
    }
  }}
>
  {req.accepting ? "Accepting..." : "Accept Now"}
</button>

    </div>
  ))}
</div>

            <div className="row">
              {renderSidebar()}
              
              <div className="col-md-9">
                <div className="mb-4">

  <div className="d-flex flex-wrap gap-2">

    {/* HIRING */}
    <button
      className={`btn btn-sm rounded-3 ${
        activeTab === 'hiring'
          ? 'btn-dark'
          : 'btn-light border'
      }`}
      onClick={() => setActiveTab('hiring')}
    >
      🤝 Hiring ({safeHiringRequests.length})
    </button>

    {/* REQUESTS */}
    <button
      className={`btn btn-sm rounded-3 ${
        activeTab === 'requests'
          ? 'btn-dark'
          : 'btn-light border'
      }`}
      onClick={() => setActiveTab('requests')}
    >
      📅 Requests ({safeSessionRequests.filter(r => r.status === 'pending').length})
    </button>

    {/* SCHEDULE */}
    <button
      className={`btn btn-sm rounded-3 ${
        activeTab === 'schedule'
          ? 'btn-dark'
          : 'btn-light border'
      }`}
      onClick={() => setActiveTab('schedule')}
    >
      🗓 Schedule ({scheduledSessions.length})
    </button>

    {/* PAYMENTS */}
    <button
      className={`btn btn-sm rounded-3 ${
        activeTab === 'payments'
          ? 'btn-dark'
          : 'btn-light border'
      }`}
      onClick={() => setActiveTab('payments')}
    >
      💳 Payments
    </button>

    {/* HISTORY */}
    <button
      className={`btn btn-sm rounded-3 ${
        activeTab === 'history'
          ? 'btn-dark'
          : 'btn-light border'
      }`}
      onClick={() => setActiveTab('history')}
    >
      🕘 History ({completedSessions.length})
    </button>

  </div>

</div>

                {renderTabContent()}
              </div>
            </div>
          </>
        )}

        {/* Modals */}
        {renderModals()}
      </div>
    </div>
  );
}

export default Teacher;